import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Stack,
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { ScopedCssBaseline } from '@mui/material';
import theme from '../../theme';
import ProfileForm from './ProfileForm';
import TopupForm from '../billing/method/TopupForm';
import { deleteUser } from '../../actions/user';
import { fetchJobs } from '../../actions/jobs';
import { fetchPaymentMethods } from '../../actions/paymentMethods';
import CredentialsForm from '../credentials/CredentialsForm';
import DefaultSettingsForm from './settings/DefaultSettingsForm';
import ApiKeysForm from './settings/ApiKeysForm';

export default function AccountSettings() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const jobs = useSelector((state) => state.jobs || []);
  const paymentMethods = useSelector((state) => state.paymentMethods);
  const primaryPaymentMethod = _.find(
    paymentMethods,
    (method) => method.id === user.primary_pm
  );

  const [pressedDelete, setPressedDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchJobs());
    if (!user.billing_account_id) {
      dispatch(fetchPaymentMethods());
    }
  }, [dispatch, user.billing_account_id]);

  const handleDeleteUser = () => {
    setLoading(true);
    dispatch(deleteUser());
  };

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <Container>
          <Stack spacing={3}>
            <Box>
              <Typography variant='h4' align='center' gutterBottom>
                Profile Information
              </Typography>
              <ProfileForm edit={true} />
            </Box>

            <Paper elevation={2} sx={{ p: 3 }}>
              <CredentialsForm project_uuid={user.id} />
            </Paper>

            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant='h4' align='center' gutterBottom>
                API Keys
              </Typography>
              <ApiKeysForm />
            </Paper>

            {!user.billing_account_id && (
              <Paper elevation={2} sx={{ p: 3 }}>
                <TopupForm
                  primaryPaymentMethod={primaryPaymentMethod}
                  user={user}
                />
              </Paper>
            )}

            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant='h4' align='center' gutterBottom>
                Default Job Settings
              </Typography>
              <DefaultSettingsForm />
            </Paper>

            <Paper elevation={2} sx={{ p: 3 }}>
              <Button
                variant='contained'
                color='error'
                disabled={jobs.length !== 0}
                onClick={() => setPressedDelete(true)}
              >
                Delete User
              </Button>
              {jobs.length !== 0 && (
                <Alert severity='error' sx={{ mt: 2 }}>
                  You must terminate all jobs to enable this function.
                </Alert>
              )}
            </Paper>
          </Stack>

          <Dialog open={pressedDelete} onClose={() => setPressedDelete(false)}>
            <DialogTitle>Delete Your Account</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to delete your account? This action cannot
                be undone. If you have a credit balance, all credits will be
                forfeited upon account deletion.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setPressedDelete(false)}
                disabled={loading}
              >
                No
              </Button>
              <Button
                color='error'
                onClick={handleDeleteUser}
                loading={loading}
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
